import { Injectable, Optional } from '@angular/core';

export class GoogleMapsConfigServiceConfig {
  apiKey: string;
}
@Injectable()
export class GoogleMapsConfigService {
  apiKey: string;

  constructor(@Optional() private config?: GoogleMapsConfigServiceConfig) {
    this.apiKey = this.config?.apiKey ?? '';
  }

  load(): Promise<void> {
    if (window.google && window.google.maps) {
      return Promise.resolve();
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
    script.defer = true;
    script.async = true;

    return new Promise<void>((resolve, reject) => {
      script.onload = () => {
        resolve();
      };

      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
}
